export default __webpack_public_path__ + "static/media/BoatIconGreen.3e2ef4c6.svg";